function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi";
import { FilterContext, UserContext } from "../index";
import "./RiskUserHistory.css";
import { RISKY_USER_HISTORY_QUERY } from "./query";
import Loader from "./../Loader/Loader";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import moment from "moment-timezone";
import isToday from "date-fns/isToday";
import Accordion from "react-bootstrap/Accordion";
import { arrayToStringOutput } from "./../SideMenu/Header";
import { PlanUpgradeMessage } from "./../WorkLoadAnalysisReport/WorkLoadAnalysisReport";
var RiskUserHistory = function RiskUserHistory(props) {
  var _riskyUserHistory$ris, _riskyUserHistory$ris2, _riskyUserHistory$use, _riskyUserHistory$use2;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    keyData = _React$useState2[0],
    setKeyData = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isCheck = _React$useState4[0],
    setIsCheck = _React$useState4[1];
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationBilling = _React$useContext.organisationBilling,
    organisationSettings = _React$useContext.organisationSettings,
    filterRole = _React$useContext.role,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus;
  var Link = props.linkComponent,
    linkProps = props.linkProps;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  React.useEffect(function () {
    if (from == "web" && filterRole == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [filterRole]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && filterRole != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  if (organisationBilling.planName == "free") {
    return /*#__PURE__*/React.createElement(PlanUpgradeMessage, {
      displayName: user.displayName,
      history: props === null || props === void 0 ? void 0 : props.history
    });
  }
  var _useQuery = useQuery(RISKY_USER_HISTORY_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userRole: filterRole
      }
    }),
    riskyUserData = _useQuery.data,
    riskyUserError = _useQuery.error,
    riskyUserLoading = _useQuery.loading,
    refetch = _useQuery.refetch;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [props.location.key]);
  if (riskyUserLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (riskyUserError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!riskyUserData) {
    return null;
  }
  var riskyUserHistory = riskyUserData === null || riskyUserData === void 0 ? void 0 : riskyUserData.riskyUserHistory;
  var handleKey = function handleKey(key) {
    setKeyData(key);
    setIsCheck(function (prev) {
      return prev === true ? false : true;
    });
  };
  var startDayUnix = Number(moment(startDate).format("x"));
  var endDayUnix = Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x"));
  var dateFilter = arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  return /*#__PURE__*/React.createElement("div", {
    className: "risk-user-history-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "risk-user-history-root-button"
  }, /*#__PURE__*/React.createElement("span", {
    className: "risk-user-history-filter-title"
  }, dateFilter), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/settings/risk-settings"), {
    key: "screenshots"
  }), /*#__PURE__*/React.createElement(Button, null, riskyUserHistory.userRuleViolated.length === 0 ? "Yet To Create A Risk Trigger" : "View Risk Tiggers", " ")))), /*#__PURE__*/React.createElement("div", {
    className: "risk-user-history-root-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "risk-user-history-root-content-risk-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "risk-user-history-root-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-risk-user-history-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-risk-user-history-list-heading"
  }, /*#__PURE__*/React.createElement("span", null, "Risky Users")), /*#__PURE__*/React.createElement("div", {
    className: "head-website-list-risk-history"
  }, /*#__PURE__*/React.createElement("span", {
    className: "head-website-list-user-count-header"
  }, " ", riskyUserHistory.userTotalCount, " ", /*#__PURE__*/React.createElement("span", {
    className: "head-website-list-user-small-header"
  }, "users")))), /*#__PURE__*/React.createElement("hr", {
    className: "head-website-list-hr"
  }), /*#__PURE__*/React.createElement("div", {
    className: "risk-user-history-content-listing"
  }, riskyUserHistory !== null && riskyUserHistory !== void 0 && (_riskyUserHistory$ris = riskyUserHistory.riskyUser) !== null && _riskyUserHistory$ris !== void 0 && _riskyUserHistory$ris.length ? riskyUserHistory === null || riskyUserHistory === void 0 ? void 0 : (_riskyUserHistory$ris2 = riskyUserHistory.riskyUser) === null || _riskyUserHistory$ris2 === void 0 ? void 0 : _riskyUserHistory$ris2.map(function (riskyUserData, key) {
    var _riskyUserData$displa, _riskyUserData$ruleDe;
    return /*#__PURE__*/React.createElement("div", {
      className: "risk-user-history-content-listing-content"
    }, riskyUserData !== null && riskyUserData !== void 0 && riskyUserData.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "risk-history-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: riskyUserData === null || riskyUserData === void 0 ? void 0 : riskyUserData.profileUrl,
      className: "team-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "risk-history-content-data-details-avatar-circle"
    }, riskyUserData === null || riskyUserData === void 0 ? void 0 : (_riskyUserData$displa = riskyUserData.displayName) === null || _riskyUserData$displa === void 0 ? void 0 : _riskyUserData$displa.charAt(0)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat(riskyUserData === null || riskyUserData === void 0 ? void 0 : riskyUserData.uniqueUrl)), {
      key: "risk-".concat(riskyUserData === null || riskyUserData === void 0 ? void 0 : riskyUserData.userId)
    }), /*#__PURE__*/React.createElement("p", {
      className: "risk-history-root-content-data-details-name-data-team-name"
    }, riskyUserData === null || riskyUserData === void 0 ? void 0 : riskyUserData.displayName)), riskyUserData === null || riskyUserData === void 0 ? void 0 : (_riskyUserData$ruleDe = riskyUserData.ruleDetails) === null || _riskyUserData$ruleDe === void 0 ? void 0 : _riskyUserData$ruleDe.map(function (ruleList, key) {
      var _ruleList$dateDetails;
      var dateList = ruleList === null || ruleList === void 0 ? void 0 : (_ruleList$dateDetails = ruleList.dateDetails) === null || _ruleList$dateDetails === void 0 ? void 0 : _ruleList$dateDetails.map(function (obj) {
        return moment(obj.date).format("DD-MMM-YYYY");
      }).join(" , ");
      return /*#__PURE__*/React.createElement("p", {
        className: "risk-history-root-content-data-details-name-data-team-name-rule-text"
      }, /*#__PURE__*/React.createElement(OverlayTrigger, {
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-team-name"
        }, " ", ruleList === null || ruleList === void 0 ? void 0 : ruleList.title)
      }, /*#__PURE__*/React.createElement("span", null, ruleList === null || ruleList === void 0 ? void 0 : ruleList.ruleName)), isToday(Number(startDate)) ? null : /*#__PURE__*/React.createElement(React.Fragment, null, "(", /*#__PURE__*/React.createElement(OverlayTrigger, {
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-team-name"
        }, " ", dateList)
      }, /*#__PURE__*/React.createElement("span", null, (ruleList === null || ruleList === void 0 ? void 0 : ruleList.dateDetails.length) > 1 ? (ruleList === null || ruleList === void 0 ? void 0 : ruleList.dateDetails.length) + " days" : (ruleList === null || ruleList === void 0 ? void 0 : ruleList.dateDetails.length) + " day")), ")"));
    })));
  }) : /*#__PURE__*/React.createElement("div", null, "No data found !!!")))), /*#__PURE__*/React.createElement("div", {
    className: "risk-user-history-root-content-rule-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "risk-user-history-root-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-risk-user-history-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-risk-user-history-list-heading"
  }, /*#__PURE__*/React.createElement("span", null, "Rules violated")), /*#__PURE__*/React.createElement("div", {
    className: "head-website-list-risk-history"
  }, /*#__PURE__*/React.createElement("span", {
    className: "head-website-list-user-count-header"
  }, " ", riskyUserHistory.ruleViolationCount, " ", /*#__PURE__*/React.createElement("span", {
    className: "head-website-list-user-small-header"
  }, "violations")))), /*#__PURE__*/React.createElement("hr", {
    className: "head-website-list-hr"
  }), /*#__PURE__*/React.createElement("div", {
    className: "risk-user-root-content-table-wrapper"
  }, /*#__PURE__*/React.createElement(Accordion, null, riskyUserHistory !== null && riskyUserHistory !== void 0 && (_riskyUserHistory$use = riskyUserHistory.userRuleViolated) !== null && _riskyUserHistory$use !== void 0 && _riskyUserHistory$use.length ? riskyUserHistory === null || riskyUserHistory === void 0 ? void 0 : (_riskyUserHistory$use2 = riskyUserHistory.userRuleViolated) === null || _riskyUserHistory$use2 === void 0 ? void 0 : _riskyUserHistory$use2.map(function (userRuleViolatedData, key) {
    return /*#__PURE__*/React.createElement("div", {
      className: "risk-rule-history-content-listing",
      onClick: function onClick() {
        return handleKey(key);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "risk-rule-history-content-listing-content"
    }, /*#__PURE__*/React.createElement(Accordion.Toggle, {
      as: Button,
      variant: "link",
      eventKey: key.toString()
    }, /*#__PURE__*/React.createElement("div", {
      className: "risk-rule-history-content-listing-content-card"
    }, /*#__PURE__*/React.createElement("span", {
      className: "risk-rule-history-content-rule-name"
    }, userRuleViolatedData.ruleName), /*#__PURE__*/React.createElement("span", {
      className: "risk-rule-history-content-rule-violations"
    }, userRuleViolatedData.userCount), keyData === key && isCheck ? /*#__PURE__*/React.createElement(HiOutlineChevronUp, {
      className: "risk-history-rule-uparrow"
    }) : /*#__PURE__*/React.createElement(HiOutlineChevronDown, {
      className: "risk-history-rule-uparrow"
    }))), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: key.toString()
    }, /*#__PURE__*/React.createElement(AccordianBody, {
      userRuleViolatedData: userRuleViolatedData
    }))));
  }) : /*#__PURE__*/React.createElement("div", null, "No data found !!!")))))));
};
var AccordianBody = function AccordianBody(props) {
  var _userRuleViolatedData;
  var userRuleViolatedData = props.userRuleViolatedData;
  return /*#__PURE__*/React.createElement("div", {
    className: "risk-user-history-content-list"
  }, userRuleViolatedData === null || userRuleViolatedData === void 0 ? void 0 : (_userRuleViolatedData = userRuleViolatedData.user) === null || _userRuleViolatedData === void 0 ? void 0 : _userRuleViolatedData.map(function (userRuleData, key) {
    var _userRuleData$display;
    return /*#__PURE__*/React.createElement("div", {
      className: "risk-user-rule-history-content-listing-content"
    }, userRuleData !== null && userRuleData !== void 0 && userRuleData.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "risk-history-card-avatar-profile-accordian"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: userRuleData === null || userRuleData === void 0 ? void 0 : userRuleData.profileUrl,
      className: "team-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "risk-rule-history-content-data-details-avatar-circle"
    }, userRuleData === null || userRuleData === void 0 ? void 0 : (_userRuleData$display = userRuleData.displayName) === null || _userRuleData$display === void 0 ? void 0 : _userRuleData$display.charAt(0)), /*#__PURE__*/React.createElement("p", {
      className: "risk-rule-history-root-content-data-details-name-data-team-name"
    }, userRuleData === null || userRuleData === void 0 ? void 0 : userRuleData.displayName));
  }));
};
export default RiskUserHistory;